export const ELEMENT_SIZE = {
  Small: "small",
  Medium: "medium",
  Large: "large",
} as const;
